import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../../../messages/commonMessages';

import { media } from '../../../styles/style-utils';

const Wrapper = styled.div`
  .slick-dots li button:before,
  .slick-dots li.slick-active button:before {
    color: white;
    font-size: 10px;
  }

  .slick-prev,
  .slick-next,
  .slick-prev:hover,
  .slick-next:hover {
    display: none;

    ${media.large`
      display: block;
      z-index: 1;
      background-color: var(--c-shark);
      width: 60px;
      height: 60px;
      padding: 20px;
    `}
  }
  .slick-prev {
    left: 0px;
  }
  .slick-next {
    right: 0px;
  }
  .slick-prev:before,
  .slick-next:before {
    content: '' !important;
  }
`;

function NextArrow(props) {
  const { className, onClick, intl } = props;
  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={intl.formatMessage(commonMessages.nextSlide)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="white"
      >
        <path d="M6.2 1L4.8 2.5l7.4 7.5-7.4 7.5L6.2 19l9-9z" />
      </svg>
    </button>
  );
}

function PrevArrow(props) {
  const { className, onClick, intl } = props;
  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={intl.formatMessage(commonMessages.prevSlide)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="white"
      >
        <path d="M4.8 10l9 9 1.4-1.5L7.8 10l7.4-7.5L13.8 1z" />
      </svg>
    </button>
  );
}

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  intl: intlShape.isRequired,
};

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  intl: intlShape.isRequired,
};

const PrevArrowWithIntl = injectIntl(PrevArrow);
const NextArrowWithIntl = injectIntl(NextArrow);

const Carousel = ({ children, className, settings }) => {
  const defaultSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrowWithIntl />,
    prevArrow: <PrevArrowWithIntl />,
  };
  return (
    <Wrapper className={className}>
      <Slider {...defaultSettings} {...settings}>
        {children}
      </Slider>
    </Wrapper>
  );
};

Carousel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  settings: PropTypes.object,
};

export default Carousel;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/main/heroBlock/Carousel.js